import { RoleFormModel } from '@user/store/roles/typings'
import { useFormikContext } from 'formik'
import { useCallback, useMemo, useState } from 'react'

type Props = {
  role?: RoleFormModel
}

export function useHandlers({ role }: Props) {
  const { submitForm, setFieldValue, values, isSubmitting } =
    useFormikContext<RoleFormModel>()

  const isAdmin = role?.name === 'Admin'

  const [openWarningModel, setOpenWarningModel] = useState(false)
  const handleWarningModel = useCallback(() => {
    setOpenWarningModel((prev) => !prev)
  }, [setOpenWarningModel])

  const createRole = useCallback(() => {
    setFieldValue('submitMode', 'create')
    handleWarningModel()
    submitForm()
  }, [setFieldValue, handleWarningModel, submitForm])

  const updateRole = useCallback(() => {
    setFieldValue('submitMode', 'update')
    if (!isAdmin) {
      handleWarningModel()
    }
    submitForm()
  }, [handleWarningModel, isAdmin, setFieldValue, submitForm])

  const disableSave = useMemo(
    () => values?.permissionOperations?.length == 0 || isSubmitting,
    [values?.permissionOperations, isSubmitting],
  )

  return {
    submitForm,
    updateRole,
    createRole,
    openWarningModel,
    handleWarningModel,
    disableSave,
  }
}
